import { render } from "./AppIknowaLogo.vue?vue&type=template&id=68cdddc7"
import script from "./AppIknowaLogo.vue?vue&type=script&lang=js"
export * from "./AppIknowaLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__